module.exports = __webpack_public_path__ + "img/d70e36fc9a146b49ad3a1df94fa99b0e.png";